import { Controller } from "stimulus"
import selectize from "selectize"

export default class extends Controller {
  static targets = [ "userId", "addFileButton" ]

  connect() {
    if (this.hasUserIdTarget) {
      $(this.userIdTarget).selectize({
        allowEmptyOption: true,
        highlight: false,
        onChange: this.userSelected.bind(this)
      })
      this.element.addEventListener("active", this.setUserStatus.bind(this, false))
      this.element.addEventListener("inactive", this.setUserStatus.bind(this, true))
    }
  }

  disconnect() {
    if (this.hasUserIdTarget) {
      this.element.removeEventListener("active", this.setUserStatus.bind(this, false))
      this.element.removeEventListener("inactive", this.setUserStatus.bind(this, true))
    }
  }

  userSelected() {
    if (this.userIdTarget.value) {
      $(this.addFileButtonTarget).removeClass("disabled")
    } else {
      $(this.addFileButtonTarget).addClass("disabled")
    }
  }

  setUserStatus(enable) {
    if (enable) {
      this.userIdTarget.selectize.enable()
    } else {
      this.userIdTarget.selectize.disable()
      $(this.userIdTarget).removeAttr("disabled")
    }
  }
}
